var cov_2c1ndepska = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/CheckboxAll.tsx",
      hash = "e1117baa396cce64ff6554c99e531133b02c9ec2",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/CheckboxAll.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 16
        }
      },
      "1": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 52
        }
      },
      "2": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 51
        }
      },
      "3": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 29
        }
      },
      "4": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 63
        }
      },
      "5": {
        start: {
          line: 26,
          column: 22
        },
        end: {
          line: 26,
          column: 31
        }
      },
      "6": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 57
        }
      },
      "7": {
        start: {
          line: 27,
          column: 46
        },
        end: {
          line: 27,
          column: 57
        }
      },
      "8": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 77
        }
      },
      "9": {
        start: {
          line: 28,
          column: 66
        },
        end: {
          line: 28,
          column: 77
        }
      },
      "10": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 16
        }
      },
      "11": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 32
        }
      },
      "12": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 65
        }
      },
      "13": {
        start: {
          line: 38,
          column: 31
        },
        end: {
          line: 38,
          column: 41
        }
      },
      "14": {
        start: {
          line: 39,
          column: 20
        },
        end: {
          line: 39,
          column: 56
        }
      },
      "15": {
        start: {
          line: 40,
          column: 26
        },
        end: {
          line: 40,
          column: 33
        }
      },
      "16": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 43,
          column: 5
        }
      },
      "17": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 42,
          column: 28
        }
      },
      "18": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 15
        }
      },
      "19": {
        start: {
          line: 48,
          column: 22
        },
        end: {
          line: 48,
          column: 32
        }
      },
      "20": {
        start: {
          line: 49,
          column: 23
        },
        end: {
          line: 49,
          column: 43
        }
      },
      "21": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 55
        }
      },
      "22": {
        start: {
          line: 50,
          column: 43
        },
        end: {
          line: 50,
          column: 55
        }
      },
      "23": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 61,
          column: 5
        }
      },
      "24": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 37
        }
      },
      "25": {
        start: {
          line: 53,
          column: 29
        },
        end: {
          line: 53,
          column: 37
        }
      },
      "26": {
        start: {
          line: 54,
          column: 16
        },
        end: {
          line: 54,
          column: 29
        }
      },
      "27": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 41
        }
      },
      "28": {
        start: {
          line: 55,
          column: 33
        },
        end: {
          line: 55,
          column: 41
        }
      },
      "29": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 60,
          column: 7
        }
      },
      "30": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 57,
          column: 19
        }
      },
      "31": {
        start: {
          line: 58,
          column: 13
        },
        end: {
          line: 60,
          column: 7
        }
      },
      "32": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 30
        }
      },
      "33": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 18
        }
      },
      "34": {
        start: {
          line: 67,
          column: 39
        },
        end: {
          line: 67,
          column: 49
        }
      },
      "35": {
        start: {
          line: 68,
          column: 14
        },
        end: {
          line: 68,
          column: 28
        }
      },
      "36": {
        start: {
          line: 69,
          column: 21
        },
        end: {
          line: 69,
          column: 58
        }
      },
      "37": {
        start: {
          line: 70,
          column: 20
        },
        end: {
          line: 70,
          column: 55
        }
      },
      "38": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 75,
          column: 5
        }
      },
      "39": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 74,
          column: 7
        }
      },
      "40": {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 73,
          column: 55
        }
      },
      "41": {
        start: {
          line: 73,
          column: 33
        },
        end: {
          line: 73,
          column: 55
        }
      },
      "42": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 12
        }
      },
      "43": {
        start: {
          line: 80,
          column: 39
        },
        end: {
          line: 80,
          column: 49
        }
      },
      "44": {
        start: {
          line: 81,
          column: 23
        },
        end: {
          line: 81,
          column: 43
        }
      },
      "45": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 86,
          column: 5
        }
      },
      "46": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 51
        }
      },
      "47": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 85,
          column: 54
        }
      },
      "48": {
        start: {
          line: 90,
          column: 22
        },
        end: {
          line: 90,
          column: 32
        }
      },
      "49": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 58
        }
      },
      "50": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 38
        }
      },
      "51": {
        start: {
          line: 92,
          column: 27
        },
        end: {
          line: 92,
          column: 38
        }
      },
      "52": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 96
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        loc: {
          start: {
            line: 14,
            column: 56
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        loc: {
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 23,
            column: 3
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        loc: {
          start: {
            line: 25,
            column: 70
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 25
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 25
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 32
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 18
          },
          end: {
            line: 45,
            column: 3
          }
        },
        line: 37
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        },
        loc: {
          start: {
            line: 47,
            column: 15
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 47
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 21
          },
          end: {
            line: 77,
            column: 3
          }
        },
        line: 66
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        },
        loc: {
          start: {
            line: 79,
            column: 56
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 79
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        },
        loc: {
          start: {
            line: 89,
            column: 11
          },
          end: {
            line: 94,
            column: 3
          }
        },
        line: 89
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 57
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 57
          }
        }],
        line: 27
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 77
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 77
          }
        }, {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 77
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 28,
            column: 34
          },
          end: {
            line: 28,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 34
          },
          end: {
            line: 28,
            column: 50
          }
        }, {
          start: {
            line: 28,
            column: 54
          },
          end: {
            line: 28,
            column: 56
          }
        }],
        line: 28
      },
      "3": {
        loc: {
          start: {
            line: 38,
            column: 12
          },
          end: {
            line: 38,
            column: 20
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 38,
            column: 18
          },
          end: {
            line: 38,
            column: 20
          }
        }],
        line: 38
      },
      "4": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }],
        line: 41
      },
      "5": {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 12
          }
        }, {
          start: {
            line: 41,
            column: 16
          },
          end: {
            line: 41,
            column: 25
          }
        }, {
          start: {
            line: 41,
            column: 29
          },
          end: {
            line: 41,
            column: 48
          }
        }, {
          start: {
            line: 41,
            column: 52
          },
          end: {
            line: 41,
            column: 69
          }
        }],
        line: 41
      },
      "6": {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 55
          }
        }, {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 55
          }
        }],
        line: 50
      },
      "7": {
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 26
          }
        }, {
          start: {
            line: 50,
            column: 30
          },
          end: {
            line: 50,
            column: 41
          }
        }],
        line: 50
      },
      "8": {
        loc: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 37
          }
        }, {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 37
          }
        }],
        line: 53
      },
      "9": {
        loc: {
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 55,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 55,
            column: 41
          }
        }, {
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 55,
            column: 41
          }
        }],
        line: 55
      },
      "10": {
        loc: {
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        }, {
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        }],
        line: 56
      },
      "11": {
        loc: {
          start: {
            line: 58,
            column: 13
          },
          end: {
            line: 60,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 13
          },
          end: {
            line: 60,
            column: 7
          }
        }, {
          start: {
            line: 58,
            column: 13
          },
          end: {
            line: 60,
            column: 7
          }
        }],
        line: 58
      },
      "12": {
        loc: {
          start: {
            line: 69,
            column: 21
          },
          end: {
            line: 69,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 21
          },
          end: {
            line: 69,
            column: 36
          }
        }, {
          start: {
            line: 69,
            column: 40
          },
          end: {
            line: 69,
            column: 58
          }
        }],
        line: 69
      },
      "13": {
        loc: {
          start: {
            line: 70,
            column: 20
          },
          end: {
            line: 70,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 20
          },
          end: {
            line: 70,
            column: 28
          }
        }, {
          start: {
            line: 70,
            column: 32
          },
          end: {
            line: 70,
            column: 55
          }
        }],
        line: 70
      },
      "14": {
        loc: {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }, {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }],
        line: 71
      },
      "15": {
        loc: {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 55
          }
        }, {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 55
          }
        }],
        line: 73
      },
      "16": {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }, {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }],
        line: 82
      },
      "17": {
        loc: {
          start: {
            line: 91,
            column: 28
          },
          end: {
            line: 91,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 28
          },
          end: {
            line: 91,
            column: 44
          }
        }, {
          start: {
            line: 91,
            column: 48
          },
          end: {
            line: 91,
            column: 50
          }
        }],
        line: 91
      },
      "18": {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 38
          }
        }, {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 38
          }
        }],
        line: 92
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/CheckboxAll.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { Component } from '../component';
import shallowEqual from '../utils/shallowEqual';
import { CHANGE_TOPIC } from '../Datum/types';
import Checkbox from '../Checkbox/Checkbox';
import { isFunc } from '../utils/is';

var TableCheckboxAll =
/*#__PURE__*/
function (_Component) {
  _inherits(TableCheckboxAll, _Component);

  var _super = _createSuper2(TableCheckboxAll);

  function TableCheckboxAll(props) {
    var _this;

    _classCallCheck(this, TableCheckboxAll);

    cov_2c1ndepska.f[0]++;
    cov_2c1ndepska.s[0]++;
    _this = _super.call(this, props);
    _this.handleUpdate = void 0;
    _this.lastValueLength = void 0;
    cov_2c1ndepska.s[1]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    cov_2c1ndepska.s[2]++;
    _this.handleUpdate = _this.forceUpdate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TableCheckboxAll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_2c1ndepska.f[1]++;
      cov_2c1ndepska.s[3]++;

      _get(_getPrototypeOf(TableCheckboxAll.prototype), "componentDidMount", this).call(this);

      cov_2c1ndepska.s[4]++;
      this.props.datum.subscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      cov_2c1ndepska.f[2]++;

      var _ref = (cov_2c1ndepska.s[5]++, nextProps),
          datum = _ref.datum;

      cov_2c1ndepska.s[6]++;

      if (!shallowEqual(this.props, nextProps)) {
        cov_2c1ndepska.b[0][0]++;
        cov_2c1ndepska.s[7]++;
        return true;
      } else {
        cov_2c1ndepska.b[0][1]++;
      }

      cov_2c1ndepska.s[8]++;

      if (this.lastValueLength !== ((cov_2c1ndepska.b[2][0]++, datum.getValue()) || (cov_2c1ndepska.b[2][1]++, [])).length) {
        cov_2c1ndepska.b[1][0]++;
        cov_2c1ndepska.s[9]++;
        return true;
      } else {
        cov_2c1ndepska.b[1][1]++;
      }

      cov_2c1ndepska.s[10]++;
      return false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_2c1ndepska.f[3]++;
      cov_2c1ndepska.s[11]++;

      _get(_getPrototypeOf(TableCheckboxAll.prototype), "componentWillUnmount", this).call(this);

      cov_2c1ndepska.s[12]++;
      this.props.datum.unsubscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "getFilterData",
    value: function getFilterData() {
      cov_2c1ndepska.f[4]++;

      var _ref2 = (cov_2c1ndepska.s[13]++, this.props),
          _ref2$col = _ref2.col,
          col = _ref2$col === void 0 ? (cov_2c1ndepska.b[3][0]++, {}) : _ref2$col,
          data = _ref2.data;

      var colTemp = (cov_2c1ndepska.s[14]++, col);

      var _ref3 = (cov_2c1ndepska.s[15]++, colTemp),
          filterAll = _ref3.filterAll;

      cov_2c1ndepska.s[16]++;

      if ((cov_2c1ndepska.b[5][0]++, data) && (cov_2c1ndepska.b[5][1]++, filterAll) && (cov_2c1ndepska.b[5][2]++, Array.isArray(data)) && (cov_2c1ndepska.b[5][3]++, isFunc(filterAll))) {
        cov_2c1ndepska.b[4][0]++;
        cov_2c1ndepska.s[17]++;
        return filterAll(data);
      } else {
        cov_2c1ndepska.b[4][1]++;
      }

      cov_2c1ndepska.s[18]++;
      return data;
    }
  }, {
    key: "getChecked",
    value: function getChecked() {
      cov_2c1ndepska.f[5]++;

      var _ref4 = (cov_2c1ndepska.s[19]++, this.props),
          datum = _ref4.datum;

      var filterData = (cov_2c1ndepska.s[20]++, this.getFilterData());
      cov_2c1ndepska.s[21]++;

      if ((cov_2c1ndepska.b[7][0]++, datum.length === 0) || (cov_2c1ndepska.b[7][1]++, !filterData)) {
        cov_2c1ndepska.b[6][0]++;
        cov_2c1ndepska.s[22]++;
        return false;
      } else {
        cov_2c1ndepska.b[6][1]++;
      }

      var checked;
      cov_2c1ndepska.s[23]++;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = filterData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var d = _step.value;
          cov_2c1ndepska.s[24]++;

          if (datum.disabled(d)) {
            cov_2c1ndepska.b[8][0]++;
            cov_2c1ndepska.s[25]++;
            continue;
          } else {
            cov_2c1ndepska.b[8][1]++;
          }

          var p = (cov_2c1ndepska.s[26]++, this.check(d));
          cov_2c1ndepska.s[27]++;

          if (p === 'indeterminate') {
            cov_2c1ndepska.b[9][0]++;
            cov_2c1ndepska.s[28]++;
            return p;
          } else {
            cov_2c1ndepska.b[9][1]++;
          }

          cov_2c1ndepska.s[29]++;

          if (checked === undefined) {
            cov_2c1ndepska.b[10][0]++;
            cov_2c1ndepska.s[30]++;
            checked = p;
          } else {
            cov_2c1ndepska.b[10][1]++;
            cov_2c1ndepska.s[31]++;

            if (checked !== p) {
              cov_2c1ndepska.b[11][0]++;
              cov_2c1ndepska.s[32]++;
              return 'indeterminate';
            } else {
              cov_2c1ndepska.b[11][1]++;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      cov_2c1ndepska.s[33]++;
      return checked;
    }
  }, {
    key: "check",
    value: function check(d) {
      cov_2c1ndepska.f[6]++;

      var _ref5 = (cov_2c1ndepska.s[34]++, this.props),
          datum = _ref5.datum,
          treeColumnsName = _ref5.treeColumnsName;

      var p = (cov_2c1ndepska.s[35]++, datum.check(d));
      var children = (cov_2c1ndepska.s[36]++, (cov_2c1ndepska.b[12][0]++, treeColumnsName) && (cov_2c1ndepska.b[12][1]++, d[treeColumnsName]));
      var isArray = (cov_2c1ndepska.s[37]++, (cov_2c1ndepska.b[13][0]++, children) && (cov_2c1ndepska.b[13][1]++, Array.isArray(children)));
      cov_2c1ndepska.s[38]++;

      if (isArray) {
        cov_2c1ndepska.b[14][0]++;
        cov_2c1ndepska.s[39]++;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var c = _step2.value;
            cov_2c1ndepska.s[40]++;

            if (this.check(c) !== p) {
              cov_2c1ndepska.b[15][0]++;
              cov_2c1ndepska.s[41]++;
              return 'indeterminate';
            } else {
              cov_2c1ndepska.b[15][1]++;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else {
        cov_2c1ndepska.b[14][1]++;
      }

      cov_2c1ndepska.s[42]++;
      return p;
    }
  }, {
    key: "handleChange",
    value: function handleChange(_, checked, index) {
      cov_2c1ndepska.f[7]++;

      var _ref6 = (cov_2c1ndepska.s[43]++, this.props),
          datum = _ref6.datum,
          treeColumnsName = _ref6.treeColumnsName;

      var filterData = (cov_2c1ndepska.s[44]++, this.getFilterData());
      cov_2c1ndepska.s[45]++;

      if (checked) {
        cov_2c1ndepska.b[16][0]++;
        cov_2c1ndepska.s[46]++;
        datum.add(filterData, index, treeColumnsName);
      } else {
        cov_2c1ndepska.b[16][1]++;
        cov_2c1ndepska.s[47]++;
        datum.remove(filterData, index, treeColumnsName);
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_2c1ndepska.f[8]++;

      var _ref7 = (cov_2c1ndepska.s[48]++, this.props),
          datum = _ref7.datum;

      cov_2c1ndepska.s[49]++;
      this.lastValueLength = ((cov_2c1ndepska.b[17][0]++, datum.getValue()) || (cov_2c1ndepska.b[17][1]++, [])).length;
      cov_2c1ndepska.s[50]++;

      if (datum.limit === 1) {
        cov_2c1ndepska.b[18][0]++;
        cov_2c1ndepska.s[51]++;
        return null;
      } else {
        cov_2c1ndepska.b[18][1]++;
      }

      cov_2c1ndepska.s[52]++;
      return (
        /*#__PURE__*/
        React.createElement(Checkbox, Object.assign({}, this.props, {
          checked: this.getChecked(),
          onChange: this.handleChange,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 93,
            columnNumber: 12
          }
        }))
      );
    }
  }]);

  return TableCheckboxAll;
}(Component);

export { TableCheckboxAll as default };